import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';

@Component({
  selector: 'g10-route-holiday-form',
  templateUrl: './route-holiday-form.component.html',
  styleUrls: ['./route-holiday-form.component.css']
})
export class RouteHolidayFormComponent implements OnInit {

  @Input() matFormSize = '13px';
  @Input() popup = true;
  @Input() modalTitle = 'Holiday Configuration';
  @Input() updateRouteOnly: boolean = false; 
  @Input('selectedHoliday') holidayInfo:any = [];
  @Output() closeEvent = new EventEmitter();
  @Output() result = new EventEmitter();

  public routeOptions: any = [];
  public selectedRoute: any = [];
  public holidayOptions: any = [];
  public selectedHoliday: any = [];
  @ViewChild('routeSearch') routeSearchTextBox: ElementRef;
  routeSearchChangeObserver: any;
  public routeSearchVal: any = '';
  public showRouteField: boolean = false;
  public showHolidayField: boolean = false;

  public formObject: any = {
    routeID: '',
    holidayPattern:'',
  };
  public errorObject = JSON.parse(JSON.stringify(this.formObject));
  //Button
  public submitBtnPressed: boolean = false;

  constructor(
    private comService: CommonServices,
    private api: ApiService,
  ) { }

  ngOnInit(): void {
    this.loadRouteData();
    this.loadHolidayData();
  }

  routeOptionFn(res: any) {
    let returnData = [];
    if (res.data && res.data.length > 0) {
      returnData = res.data.map((item) => {
        let option = { name: item.title, value: item.routeID };/*  ,badge: '1', badgeClass:'bg-primary text-white rounded-pill px-2 badgePosRel' }; */
        return option;
      })
    }
    return returnData;
  }
  holidayOptionFn(res: any) {
    let returnData = []; 
    console.log('res',res,res && res.data && Object.keys(res.data).length > 0);
    if(res && res.data && Object.keys(res.data).length > 0){
      Object.keys(res.data).filter((item) => {
        Object.keys(res.data[item]).filter((holiday) => {
          let option = {
            name: holiday,
            value: holiday,
            badge: item == 'date' ? 'D' : 'W',
            badgeColor: 'light'
          };
          returnData.push(option);
        });
      });
    }
    console.log(returnData);
    return returnData;
  }

  async loadHolidayData(search?) {
    this.showHolidayField = false;
    const obj = {};
    if (search) obj['search'] = search;
    this.holidayOptions = [];
    // let data: any = await this.comService.getAPILoopData('getHolidays', obj).catch((e) => { console.log('api loop error', e); })
    let data:any  = await this.api.getHolidays(obj).catch((e)=>{ console.log(e) });
    if (data.length > 0) {
      this.holidayOptions = Object.keys(data).filter((item) => {
        Object.keys(data[item]).filter((holiday) => {
          try {
            let option = {
              name: holiday,
              value: holiday,
              badge: item == 'date' ? 'D' : 'W',
              badgeColor: 'light'
            };
            return option;
          } catch (err) {
            console.log('Holiday', err);
          }
        })
      });
    }
  }

  async loadRouteData(title?) {
    this.showRouteField = false;
    let obj = {};
    if (title) obj['title'] = title;
    let data: any = await this.comService.getAPILoopData('transportMangerRouteList', obj).catch((e) => { console.log('api loop error', e); })
    if (data.length > 0) {
      this.routeOptions = data.map((item) => {
        let option = { name: item.title, value: item.routeID };
        return option;
      })
    }
    this.showRouteField = true;
  }

  /* Dropdown */

  dropdownChangeEvent(value, key) {
    if (Array.isArray(value)) value = value.filter((val) => val != 'All');
    this.formObject[key] = value;
    this.validation();
    // this.dropdownSelectionResult(value, 'selectedRoute', 'routeOptions', 'showRouteField', 'routeSearchTextBox');
  }

  /* Form Validation */
  validation() {
    let objectKeys = Object.keys(this.formObject);
    if (this.updateRouteOnly) { objectKeys = objectKeys.filter(key => key != 'holidayPattern'); }
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (this.formObject[key] == '' || this.formObject[key] == undefined || this.formObject[key] == null || this.formObject[key].length <= 0) {
        if (key == 'routeID') this.errorObject[key] = "Route is required";
        else this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      }
    }
    return isValid;
  }

  closePopup() {
    this.closeEvent.emit(true);
  }

  onSubmit() {
    this.submitBtnPressed = true;
    let isValid = this.validation();
    if (isValid) {
      let returnObj = {
        routeID: this.formObject.routeID,
        holiday: this.formObject.holidayPattern,
      }
      if(this.updateRouteOnly){
        let holiday = this.holidayInfo;
        if(!Array.isArray(holiday)) holiday = [holiday];
        returnObj['holiday'] = holiday.map((item)=> item.key);
      }
      this.result.emit(returnObj);
      this.closeEvent.emit(true);
    }
  }
}
